"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "enna": {
    "da0b5329": [{
      "hkey": "54e72761",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico-zona-centrale": [{
      "hkey": "54e72761",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9d291ccc": [{
      "hkey": "54e72761",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico-zona-marginale": [{
      "hkey": "54e72761",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "enna"
    }],
    "e46533d0": [{
      "hkey": "d7e202a2",
      "slug": "enna-bassa",
      "name": "Enna Bassa",
      "primary": true,
      "skipSearch": false
    }],
    "enna-bassa-periferia": [{
      "hkey": "d7e202a2",
      "slug": "enna-bassa",
      "name": "Enna Bassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fac0c873": [{
      "hkey": "38344308",
      "slug": "pergusa-centro-abitato",
      "name": "Pergusa centro abitato",
      "primary": true,
      "skipSearch": false
    }],
    "pergusa": [{
      "hkey": "38344308",
      "slug": "pergusa-centro-abitato",
      "name": "Pergusa centro abitato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "enna"
    }],
    "896df500": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "skipSearch": false
    }],
    "pergusa-lago-zona-riserva-speciale": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67cad268": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "skipSearch": false
    }],
    "zona-castello-lombardia": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60d26a70": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "skipSearch": false
    }],
    "zona-edificata-periferica": [{
      "hkey": "4790f49b",
      "slug": "enna",
      "name": "Enna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7727082b": [{
      "hkey": "d7e202a2",
      "slug": "enna-bassa",
      "name": "Enna Bassa",
      "primary": true,
      "skipSearch": false
    }],
    "zona-universita-enna-bassa": [{
      "hkey": "d7e202a2",
      "slug": "enna-bassa",
      "name": "Enna Bassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "enna"
    }]
  }
};
exports["default"] = _default;